import React from 'react';
import { Menu } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { BACKGROUND_HEADER } from '../colors';
import { colorsModeUI } from '../modeUI';
import './index.css';

/**
 * Header
 * Props(parameters)
 * @param image logo: required
 * @param string logoWidth
 * @param string title: required
 * @param string titleWidth
 * @param string tooltipLogo
 * @param func onClick: onClick event for the logo
 * @param string mode: defines the mode UI [MODE_DARK, MODE_LIGHT]
 */
export default class Header extends React.PureComponent {
  render() {
    const { logo, title, onClick, mode, logoWidth, tooltipLogo, titleWidth } =
      this.props;
    let background = BACKGROUND_HEADER;
    const styleTitleHeader = {};
    /* mode UI: dark mode/light mode */
    if (mode !== null) {
      background = colorsModeUI(mode).HEADER_BACKGROUND_COLOR;
      styleTitleHeader.color = colorsModeUI(mode).HEADER_COLOR;
    }
    if (titleWidth) {
      styleTitleHeader.maxWidth = titleWidth;
      styleTitleHeader.overflow = 'hidden';
    }
    const styles = { background };
    const styleLogo = { width: logoWidth };
    const menuItemsProps = {};
    if (onClick != null) {
      menuItemsProps.onClick = onClick;
    }

    return (
      <Menu
        className="ui-header-navigation"
        fixed="top"
        borderless
        inverted
        style={styles}
      >
        <Menu.Item className="menu-item" {...menuItemsProps}>
          {logo && <img src={logo} alt={tooltipLogo} style={styleLogo} />}
          <p className="title" style={styleTitleHeader}>
            {title}
          </p>
        </Menu.Item>
      </Menu>
    );
  }
}

Header.propTypes = {
  logo: PropTypes.node.isRequired,
  logoWidth: PropTypes.string,
  title: PropTypes.string.isRequired,
  titleWidth: PropTypes.string,
  tooltipLogo: PropTypes.string,
  onClick: PropTypes.func,
  mode: PropTypes.string,
};

Header.defaultProps = {
  logoWidth: '43px',
  titleWidth: null,
  tooltipLogo: 'Logo',
  onClick: null,
  mode: null,
};
